import React, { ReactNode } from 'react';
export interface ErrorProps {
    valueToObserve?: string;
    fallback: ReactNode;
}
export interface ErrorState {
    hasError: boolean;
    error: Error | null;
}

export default class ErrorBoundary extends React.Component<ErrorProps, ErrorState> {
    state = { hasError: false, error: null };

    static getDerivedStateFromError(error: Error) {
        console.log(error);
        return {
            hasError: true,
            error,
        };
    }
    componentDidUpdate(prevProps: ErrorProps) {
        if (prevProps.valueToObserve !== this.props.valueToObserve) {
            this.setState({ hasError: false });
        }
    }

    render(): React.ReactNode {
        return !this.state.hasError ? this.props.children : this.props.fallback;
    }
}
